import React, { useEffect } from 'react';
import { Link, Switch, Route, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { BasicContent } from '../components';
import { Loading, Paginate } from '~/components';
import { loadRecursos, removerRecurso } from '~/store/modules/recurso/action';
import Create from '../Create';
import Edit from '../Edit';
import Show from '../Show';

const List = () => {
  let location = useLocation();
  let modal = location.state && location.state.modal;
  const dispatch = useDispatch();
  const { recursos } = useSelector(
    ({ RecursoReducer }) => RecursoReducer
  );

  useEffect(() => {
    dispatch(loadRecursos());
  }, [dispatch]);

  const breadcrumb = {
    label: 'Lista',
    to: '/recurso',
    active: false,
  };

  const handleRemove = async (event) => {
    const id = event.target.value;
    Swal.fire({
      title: 'Remover?',
      text: 'Deseja Remover esse item?!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim!',
      cancelButtonText: 'Não'
    }).then(async (result) => {
      if (result.value) {
        try {
          await dispatch(removerRecurso(id));
          await Swal.fire('Sucesso',
            'Removido com sucesso!',
            'success');
          dispatch(loadRecursos());
        } catch (error) {
          await Swal.fire('Erro',
            'Erro ao Remover',
            'error');
        }
      }
    })
  };
  return (
    <>
      {modal && (
        <Switch>
          <Route
            children={<Create />}
            path="/recurso/create"
          />
          <Route
            children={<Show />}
            exact
            path="/recurso/:recurso_id/detalhe"
          />
          <Route
            children={<Edit />}
            exact
            path="/recurso/:recurso_id/edit"
          />
        </Switch>
      )}
      <BasicContent breadcrumb={breadcrumb}>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Lista</h2>

            <div className="card-tools">
              <Link
                className="btn btn-success"
                to={{
                  pathname: '/recurso/create',
                  state: { modal: true },
                }}
              >
                <i className="fa fa-plus" /> Novo
              </Link>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-sm table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Rota</th>
                    <th className="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {recursos.data &&
                    recursos.data.map((recurso, index) => (
                      <tr key={index}>
                        <td>{recurso.id}</td>
                        <td>{recurso.nome}</td>
                        <td>{recurso.nome_rota}</td>
                        <td>
                          <div className="btn-group float-right">
                            <Link
                              className="btn btn-info"
                              to={{
                                pathname: `/recurso/${recurso.id}/detalhe`,
                                state: { modal: true },
                              }}
                            >
                              <FaEye /> Detalhes
                            </Link>
                            <Link
                              className="btn btn-default"
                              to={{
                                pathname: `/recurso/${recurso.id}/edit`,
                                state: { modal: true },
                              }}
                            >
                              <FaEdit /> Editar
                            </Link>
                            <button
                              className="btn btn-danger"
                              onClick={handleRemove}
                              value={recurso.id}
                            >
                              <FaTrash /> Remover
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {!recursos.data && <Loading />}
            </div>
          </div>
          <div className="card-footer clearfix">
            <Paginate
              load={loadRecursos}
              meta={recursos.meta}
            />
          </div>
        </div>
      </BasicContent>
    </>
  );
};

export default List;
